import { apiClient } from '../api/apiClient';

export const analyticsService = {
    getAnalytics(timeFrame) {
        return apiClient.get(`analytics?timeFrame=${encodeURIComponent(timeFrame)}`);
    }
};
